// Configurazione
const phoneNumber = '393454995693';
const message = 'Salve, ho bisogno di informazioni:';
const encodedMessage = encodeURIComponent(message);
const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

// Crea il widget
function createWidget() {
    const widgetHTML = `
        <!-- Widget WhatsApp -->
        <div id="whatsapp-widget">
            <!-- Versione Mobile -->
            <a id="whatsapp-mobile" href="${whatsappUrl}" target="_blank">
                <img src="https://cdn.shopify.com/s/files/1/0632/4541/8748/files/logo_whatsapp_1.png?v=1762502888" 
                     alt="WhatsApp">
            </a>

            <!-- Versione Desktop - icona cliccabile -->
            <div id="whatsapp-desktop-icon">
                <img src="https://cdn.shopify.com/s/files/1/0632/4541/8748/files/logo_whatsapp_1.png?v=1762502888" 
                     alt="WhatsApp">
            </div>
        </div>

        <!-- Modal QR Code (solo desktop) -->
        <div id="qr-modal">
            <div id="qr-content">
                <button id="close-modal">×</button>
                <img id="qr-code" src="" alt="QR Code WhatsApp">
                <p><strong>Scansiona questo QRCode da smartphone<br>per avviare una conversazione WhatsApp</strong></p>
            </div>
        </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', widgetHTML);
}

// Genera QR Code
function generateQRCode() {
    const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(whatsappUrl)}`;
    document.getElementById('qr-code').src = qrCodeUrl;
}

// Gestione modal QR Code (solo desktop)
function initModalQRCode() {
    const desktopIcon = document.getElementById('whatsapp-desktop-icon');
    const modal = document.getElementById('qr-modal');
    const closeBtn = document.getElementById('close-modal');

    if (desktopIcon) {
        desktopIcon.addEventListener('click', () => {
            modal.classList.add('active');
        });
    }

    closeBtn.addEventListener('click', () => {
        modal.classList.remove('active');
    });

    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.classList.remove('active');
        }
    });
}

// Inizializza tutto
function init() {
    createWidget();
    generateQRCode();
    initModalQRCode();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}